import { connect } from 'react-redux'
import { RootState, store } from '../state/store'
// import { setPasswordAction, setSelectedFactorAction, setUsernameAction } from '../state/userdata'
import { useNavigate } from 'react-router-dom'
import { POPUPTYPE, setCurrentPopupAction } from '../state/appdata'
import { GL } from '../services/services'







const mapState = (state: RootState) => ({
})


const mapDispatch = {
    setPopup: (popup: POPUPTYPE) => (setCurrentPopupAction(popup))
}
type StateProps = ReturnType<typeof mapState>
type DispatchProps = typeof mapDispatch

type Props = StateProps & DispatchProps

const NumeroNonValido = (props: Props) => {

    const navigate = useNavigate()


    return (
        <div className="popup">
            <div className='closePopup' onClick={e => props.setPopup('NONE')}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5.5 18.5L18.5 5.5M18.5 18.5L5.5 5.5" stroke="#0D0D0D" strokeLinecap="round" strokeLinejoin="round" />
            </svg></div>
            <div className='contentPopup'>
                <h3>Numero non valido</h3>
                <p> Il numero di telefono inserito non risulta valido</p>
            </div>


        </div >
    )
}

export default connect(
    mapState,
    mapDispatch
)(NumeroNonValido)